import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { SlidersHorizontal } from "lucide-react";

/** "Show advanced fields" switch shared by the Create and Edit order forms. */
export function AdvancedFieldsToggle({
  checked,
  onCheckedChange,
  id = "show-advanced-fields",
}: {
  checked: boolean;
  onCheckedChange: (next: boolean) => void;
  id?: string;
}) {
  return (
    <div className="flex items-center gap-2">
      <Switch id={id} checked={checked} onCheckedChange={onCheckedChange} />
      <Label
        htmlFor={id}
        className="flex cursor-pointer select-none items-center gap-1.5 text-sm font-medium"
      >
        <SlidersHorizontal className="h-4 w-4" />
        Show advanced fields
      </Label>
    </div>
  );
}